import { useState } from "react";
import DynamicTable from "../../../../../utils/Table/DynamicTable";
import AdminAppCardWrapper from "../../Apps/AdminAppChild/AdminAppCardWrapper";
import AdminAppContainer from "../../Apps/AdminAppChild/AdminAppContainer";
import { BASE_URL } from "../../../../../constant/apiUrl";
import { useDispatch } from "react-redux";
import { handleRowOrderChange, modifiedArray } from "./commonfunction";
import Loading from "../../../../../utils/Loader";
import RenderActions from "../../CommonComponent/RenderActions";
import { Icon } from "pepsico-ds";
import { useNavigate } from "react-router-dom";

const columns = [
  {
    id: "name",
    label: "PAGE TITLE",
    width: "200px",
  },

  { id: "createdBy", label: "CREATED", width: "200px" },
  { id: "modifiedBy", label: "LAST MODIFIED", width: "200px" },
  { id: "navigationType", label: "TYPE", width: "200px", cellStyle: "cellStyle" },
  { id: "status", label: "STATUS", width: "200px" },
  { id: "actions", label: "", width: "80px" },
];
const ChildTable = ({ row }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const renderActions = (row, col) => {
    if (row?.navigationType === "INTERNAL") {
    return (
      <Icon
        alt="edit"
        icon="edit"
        size="medium"
        style={{ color: "#005cbc" }}
        onClick={(e) => {
          e.stopPropagation();
          navigate(`/admin/pageBuilder/${row.pageId}`);
        }}
      />
    );
    }
  };
  const dispatch = useDispatch();
  const handleRowOrder = async (rows) => {
    const result = {
      pageId: row.id,
      sectionIds: rows.map((item) => item.id),
    };
    await handleRowOrderChange(
      `${BASE_URL}/admin/order/subpages`,
      result,
      setLoading,
      dispatch
    );
  };

  const cellRenderer = (value, row) => {
    if (row?.navigationType === "INTERNAL_GROUP") {
      return "Page Group";
    }
    return "Page";
  };

  return (
    <>
      {loading && <Loading />}
      <AdminAppContainer>
        <AdminAppCardWrapper>
          <DynamicTable
            columns={columns}
            rows={row?.children}
            pagination={false}
            onRowOrderChange={(newOrder) => {
              handleRowOrder(newOrder);
            }}
            onRowClick={(row) => {}}
            enableDragAndDrop={true}
            renderActions={renderActions}
            cellRenderer={cellRenderer}
          />
        </AdminAppCardWrapper>
      </AdminAppContainer>
    </>
  );
};

export default ChildTable;
